export default ({
  state: {
    // Mesa Ayuda - Soliciudes

    // Configuraciones
    FamiliaCaracterisiricForm: [
      { field: 'selectDataServer', name: 'Caracteristica', nameid: 'caracteristica_id', url: '/catalogo/caracteristicas', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Orden', nameid: 'order', rules: true, cols: 12 }
    ],
    EmpleadoForm: [
      { field: 'text', type: 'text', name: 'Clave empleado', nameid: 'cve_empleado', rules: true, cols: 4 },
      { field: 'textDatePicker', name: 'Fecha de Alta', nameid: 'fecha_alta', rules: true, cols: 4 },
      // { field: 'select', name: 'Estatus', nameid: 'estatus', items: ['Alta', 'Comision', 'Licencia', 'Baja'], rules: true, cols: 4 },
      { field: 'text', type: 'text', name: 'Nombres', nameid: 'nombres', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Apellidos', nameid: 'apellidos', rules: true, cols: 12 },
      { field: 'textDatePicker', name: 'Fecha de Nacimiento', nameid: 'fecha_nac', rules: true, cols: 4 },
      { field: 'text', type: 'text', name: 'R.F.C.', nameid: 'rfc', rules: true, cols: 4 },
      { field: 'text', type: 'text', name: 'C.U.R.P.', nameid: 'curp', rules: true, cols: 4 },
      { field: 'dropMenuTreeviewDataServer', name: 'Departamento', nameid: 'departamento_id', objectname: 'departamento', value: 'id', url: '/empresa/departamentos/children', rules: true, cols: 12 }
    ],
    EmpleadoImportForm: [
      { field: 'fileInputDataServer', name: 'Layout Empleados', nameid: 'file', accept: '.xlsx,.xls', rules: true, cols: 12 }
    ],
    // Configuraciones / Accesos - USUARIO
    UsersForm: [
      { field: 'text', type: 'text', name: 'Nombre Usuario', nameid: 'usuario', rules: true, cols: 12 },
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'empleado_id', url: '/empresa/empleados/find', itemValue: 'id', rules: true, cols: 12 },
      { field: 'textEmail', type: 'email', name: 'Correo Electrónico', nameid: 'email', rules: true, cols: 12 },
      { field: 'text', type: 'password', name: 'Contraseña', nameid: 'password', rules: true, cols: 6 },
      { field: 'text', type: 'password', name: 'Confirmar Contraseña', nameid: 'confirmpassword', rules: true, cols: 6 }
    ],
    UsersUpdateForm: [
      { field: 'text', type: 'text', name: 'Nombre Usuario', nameid: 'usuario', rules: true, cols: 12 },
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'empleado_id', objectname: 'empleado', url: '/empresa/empleados/find', itemValue: 'id', rules: true, cols: 12 },
      { field: 'textEmail', type: 'email', name: 'Correo Electrónico', nameid: 'email', rules: true, cols: 12 }

    ],
    PasswordUpdateForm: [
      { field: 'text', type: 'password', name: 'Nueva Contraseña', nameid: 'new_password', rules: true, cols: 12 },
      { field: 'text', type: 'password', name: 'Confirmar Contraseña', nameid: 'other_new_password', rules: true, cols: 12 }
    ],
    AssignRoles: [
      { field: 'viewText', name: 'Nombre Colaborador', nameid: 'NombreCompleto', cols: 12 },
      { field: 'viewText', name: 'Nombre Usuario', nameid: 'usuario', cols: 12 },
      { field: 'selectDataServer', name: 'Rol', nameid: 'rol_id', url: '/empresa/roles', rules: true, cols: 12 }
    ],
    RemoveRol: [
      { field: 'messageViewText', name: 'Estas seguro de eliminar el rol ?', classMain: 'text-center ma-auto text-h3', cols: 12 },
      { field: 'messageViewText', name: 'no podra revertir este moviminiento !!', classMain: 'text-center ma-auto title', cols: 12 }
    ],
    // Configuraciones / Accesos - ROLES
    RoleForm: [
      { field: 'text', type: 'text', name: 'Clave Role', nameid: 'slug', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Nombre Role', nameid: 'nombre', rules: true, cols: 12 }
    ],

    // Configuraciones / Accesos - PERMISOS
    PermisosForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Clave permiso', nameid: 'slug', rules: true, cols: 12 },
      { field: 'textArea', name: 'descripción', nameid: 'descripcion', dimens: 'input-7-1', rules: true, cols: 12 }
    ],
    // Catalogo
    DepartamentosForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'searchDataServer', name: 'Jefe o encargado', nameid: 'empleado_id', objectname: 'encargado', url: '/empresa/empleados/find', itemValue: 'id', rules: true, cols: 12 }
    ],
    ConceptosForm: [
      { field: 'text', type: 'text', name: 'Concepto', nameid: 'Conceptos', rules: true, cols: 12 }
    ],
    TiposDatosForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'textArea', name: 'Configuracion', nameid: 'default', dimens: 'input-7-1', rules: true, cols: 12 }
    ],
    TiposProcesosForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Abreviatura', nameid: 'abrev', rules: true, cols: 12 }
    ],
    TiposContratosForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Clave', nameid: 'clave', rules: true, cols: 12 }
    ],
    BancosForm: [
      { field: 'number', type: 'number', name: 'Clave', nameid: 'clave', rules: true, cols: 6 },
      { field: 'text', type: 'text', name: 'Abreviatura', nameid: 'abrev', rules: true, cols: 6 },
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 }
    ],
    UbpsForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 }
    ],
    ActividadesEconomicasForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Decripcion', nameid: 'descripcion', rules: true, cols: 12 }
    ],
    PartidasForm: [
      { field: 'text', type: 'text', name: 'Cuenta', nameid: 'cuenta', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Decripcion', nameid: 'descripcion', rules: true, cols: 12 }
    ],
    DocumentosForm: [
      { cols: 12, name: 'Documentos', field: 'checklist', accept: 'application/pdf', dimens: 'input-7-1', nameid: 'documentos' }
    ],
    FuentesFinanciamientoForm: [
      { field: 'number', type: 'number', name: 'Nombre', nameid: 'nombre', rules: true, cols: 6 },
      { field: 'select', type: 'text', name: 'Tipo', items: ['estatal', 'federal'], nameid: 'tipo', rules: true, cols: 6 },
      { field: 'searchDataServer', name: 'Bancos', nameid: 'banco_id', objectname: 'banco', value: 'id', url: '/catalogo/bancos/find', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Clabe', nameid: 'clabe', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Cuenta', nameid: 'cuenta', rules: true, cols: 12 }
    ],
    FamiliaForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'radioButton', name: 'Tipo De Inventario', nameid: 'insumo', items: [{ name: 'Inventariable', value: 0 }, { name: 'Controlable', value: 1 }, { name: 'Ambas', value: 2 }], row: true, cols: 12 }
    ],
    MarcaForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 }
    ],
    ProcedenciaForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 }
    ],
    CaracteristicasForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'selectDataServer', name: 'Tipo de Dato', nameid: 'tipo_dato_id', url: '/catalogo/tipo-datos', rules: true, cols: 12 }
    ],

    // MOVIMIENTOS
    MovimientosFilterForm: [
      { field: 'showMovsDataServer', name: '', nameid: 'movimientos', url: '/procesos/movimientos', default: '/procesos/movimientos', hidden: true, cols: 12 },
      { field: 'select', name: 'Tipo Movimiento', nameid: 'movs', items: ['todos', '4movs'], action: 'ShowFieldDinamic', isHidden: ['movimientos'], rules: true, cols: 12 }
    ],

    // ========== * ========== * ========== * ========== * ========== * ========== * \\
    BajasFilterForm: [
      { field: 'select', name: '', nameid: 'movimientos', url: '/procesos/movimientos', default: '/procesos/movimientos', hidden: true, cols: 12 },
      { field: 'select', name: '', nameid: 'mov', url: '/procesos/movimientos', default: '/procesos/movimientos', hidden: true, cols: 12 },
      { field: 'select', name: 'Tipo Movimiento', nameid: 'movs', items: ['todos', '4movs'], action: 'ShowFieldDinamic', isHidden: ['movimientos'], rules: true, cols: 12 }
    ],
    InventariosEquiposFilterForm: [],
    // ========== * ========== * ========== * ========== * ========== * ========== * \\

    InsumosForm: [
      { field: 'searchDataServer', name: 'Buscar Insumo', nameid: 'insumo_id', url: '/insumos/picking', objecName: 'insumo', itemValue: 'id', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Cantidad', nameid: 'cantidad', rules: true, cols: 12 }
    ],
    incidenciaForm: [
      { field: 'selectGroupDataServer', name: 'Periodo', nameid: 'ejercicio_id', url: '/nomina/config/ejercicio/periodos', rules: true, cols: 12, default: true },
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'adscripcion_id', url: '/nomina/empleados-plazas/find', itemValue: 'id', rules: true, cols: 12 },
      { field: 'number', type: 'number', name: 'Asistencia', nameid: 'horas_asistencia', cols: 6 },
      { field: 'number', type: 'number', name: 'Faltas', nameid: 'horas_faltas', cols: 6 }
    ],
    fileIncidencia: [
      { field: 'fileInputDataServer', name: 'Layout Incidenias', nameid: 'file', rules: true, cols: 12 }
    ],
    contactoForm: [
      { field: 'radioButton', name: 'Tipo Contacto', nameid: 'tipo', items: ['TELEFONO', 'CORREO', 'MOVIL'], rules: true, row: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Contacto', nameid: 'contacto', rules: true, cols: 12 }
    ],
    direccionForm: [
      { field: 'text', type: 'text', name: 'Calle', nameid: 'calle', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Numero', nameid: 'numero', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Cruzamiento 1', nameid: 'cruzamiento1', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Cruzamiento 2', nameid: 'cruzamiento2', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Codigo postal', nameid: 'cp', rules: true, cols: 6 },
      { field: 'searchDataServer', name: 'Localidad', nameid: 'localidad_id', url: '/config/cat/localidad/find', itemValue: 'id', value: 'id', cols: 6 }
    ],
    SelectDepartamentosForm: [
      { field: 'selectMultipleDataServer', name: 'Departamento', nameid: 'departamento_id', url: '/empresa/departamentos', rules: true, cols: 12 }
    ],
    RangeDateTimeForm: [
      { field: 'textDatePicker', name: 'Fecha Inicio', nameid: 'fecha_inicio', default: true, cols: 6 },
      { field: 'textDatePicker', name: 'Fecha Final', nameid: 'fecha_final', default: true, cols: 6 }
    ],
    PreviewPdfForm: [
      { field: 'previewpdf', nameid: 'ruta', params: 'data', name: 'PDF', cols: 12 }
    ],
    EditBajasForm: [
      {
        url: '/inventarios/bajas/show-bienes',
        cols: 12,
        name: 'Bajas',
        field: 'TableDataServer',
        items: [],
        value: 'id',
        nameid: 'bajas',
        ValidateEnableSelected: false,
        FieldValidateSelected: 'status_id',
        titles: [
          {
            text: 'Numero De Inventario',
            class: 'black--text',
            value: 'folio'
          },
          {
            text: 'Departamento',
            class: 'black--text',
            value: 'departamento.nombre'
          },
          {
            text: 'marca',
            class: 'black--text',
            value: 'MarcaModelo'
          },
          {
            text: 'Descripcion',
            class: 'black--text',
            value: 'caracteristicas.descripcion'
          },
          {
            text: 'Tipo',
            class: 'black--text',
            value: 'familia.padre.nombre'
          },
          {
            text: 'Motivo',
            class: 'black--text',
            value: 'caracteristicas.conceptos.conceptos'
          }
        ]
      }
    ],
    EditTransferenciasForm: [
      {
        url: '/inventarios/transferencias/show-bien',
        cols: 12,
        name: 'Transferencias',
        field: 'TableDataServer',
        items: [],
        value: 'id',
        nameid: 'transferencias',
        ValidateEnableSelected: false,
        FieldValidateSelected: 'status_id',
        titles: [
          {
            text: 'Numero De Inventario',
            class: 'black--text',
            value: 'folio'
          },
          {
            text: 'Departamento',
            class: 'black--text',
            value: 'departamento.nombre'
          },
          {
            text: 'marca',
            class: 'black--text',
            value: 'MarcaModelo'
          },
          {
            text: 'Descripcion',
            class: 'black--text',
            value: 'caracteristicas.descripcion'
          },
          {
            text: 'Tipo',
            class: 'black--text',
            value: 'familia.padre.nombre'
          }
        ]
      }
    ],
    EnviarInventarioGral: [
      { field: 'messageViewText', name: 'Enviar los inventarios asignados para transferencia ?', classMain: 'text-center ma-auto text-h4', cols: 12 },
      { field: 'messageViewText', name: 'Seleccione departamento y empelado de destino para asignarlo', classMain: 'text-center ma-auto title', cols: 12 },
      // { field: 'selectDataServer', name: 'Departamento Destino', nameid: 'destino_departamento_id', url: '/empresa/departamentos', rules: true, cols: 12 }
      { field: 'searchDataServer', name: 'Buscar Departamento Destino', nameid: 'destino_departamento_id', url: '/empresa/departamentos/find', cols: 6, rules: true, itemValue: 'id' },
      { field: 'searchDataServer', name: 'Buscar Colaborador Destino', nameid: 'destino_empleado_id', url: 'empresa/empleados/find', cols: 6, rules: true, itemValue: 'id' }
    ],

    ReporteGeneralInventariablesForm: [
      { field: 'selectDataServer', name: 'Buscar Empleado', nameid: 'empleados', url: 'empresa/empleados/all', multiple: true, search: true, action: 'ShowFieldDinamic', isHidden: ['viewPdf_reportesbienes'], rules: true, cols: 12 },
      { field: 'SelectedTreeviewDataServer', name: 'Departamentos', nameid: 'departamentos', url: '/empresa/departamentos/children', itemvalue: true, value: 'id', scroll: true, action: 'ShowFieldDinamic', isHidden: ['viewPdf_reportesbienes'], rules: true, cols: 12 },
      { field: 'radioButton', name: 'Agregar Firmas', nameid: 'firma', items: [{ name: 'SI', value: true }, { name: 'NO', value: false }], row: true, action: 'ShowFieldDinamic', isHidden: ['viewPdf_reportesbienes'], cols: 12 },
      { field: 'previewpdf', name: 'PDF', nameid: 'viewPdf_reportesbienes', url: 'inventarios/inv/asignados', params: {}, hidden: true, cols: 12 }

    ],
    TicketsDepartamentoForm: [
      { field: 'SelectedTreeviewDataServer', name: 'Departamentos', nameid: 'departamentos_tickets', url: '/empresa/departamentos/children', itemvalue: true, value: 'id', scroll: true, action: 'ShowFieldDinamic', isHidden: ['viewPdf_tickets'], isnoautoload: true, nameBtn: 'Aplicar Departamentos', rules: true, cols: 12 },
      { field: 'previewpdf', name: 'PDF', nameid: 'viewPdf_tickets', url: '/inventarios/inventariables/etiquetas', params: {}, hidden: true, cols: 12 }
    ],
    TicketsDepartamentoFormControlables: [
      { field: 'SelectedTreeviewDataServer', name: 'Departamentos', nameid: 'departamentos_tickets', url: '/empresa/departamentos/children', itemvalue: true, value: 'id', scroll: true, action: 'ShowFieldDinamic', isHidden: ['viewPdf_tickets'], isnoautoload: true, nameBtn: 'Aplicar Departamentos', rules: true, cols: 12 },
      { field: 'previewpdf', name: 'PDF', nameid: 'viewPdf_tickets', url: '/inventarios/controlables/etiquetasc', params: {}, hidden: true, cols: 12 }
    ]
  },
  getters: {
    // Mesa Ayuda - Soliciudes
    // Configuraciones
    get_EmpleadoForm (state) { return state.EmpleadoForm },
    get_EmpleadoImportForm (state) { return state.EmpleadoImportForm },
    // Configuraciones / Accesos
    get_UsersForm (state) { return state.UsersForm },
    get_UsersUpdateForm (state) { return state.UsersUpdateForm },
    get_PasswordUpdateForm (state) { return state.PasswordUpdateForm },
    // Configuraciones / Accesos - USURARIO
    get_RoleForm (state) { return state.RoleForm },
    get_FamiliaCaracterisiricForm (state) { return state.FamiliaCaracterisiricForm },
    // Configuraciones / Accesos - ROLES
    get_PermisosForm (state) { return state.PermisosForm },
    // Catalogo
    get_TiposDatosForm (state) { return state.TiposDatosForm },
    get_CaracteristicasForm (state) { return state.CaracteristicasForm },
    get_DepartamentosForm (state) { return state.DepartamentosForm },
    get_ConceptosForm (state) { return state.ConceptosForm },
    get_TiposProcesosForm (state) { return state.TiposProcesosForm },
    get_TiposContratosForm (state) { return state.TiposContratosForm },
    get_BancosForm (state) { return state.BancosForm },
    get_UbpsForm (state) { return state.UbpsForm },
    get_ActividadesEconomicasForm (state) { return state.ActividadesEconomicasForm },
    get_PartidasForm (state) { return state.PartidasForm },
    get_DocumentosForm (state) { return state.DocumentosForm },
    get_FuentesFinanciamientoForm (state) { return state.FuentesFinanciamientoForm },
    get_FamiliaForm (state) { return state.FamiliaForm },
    get_MarcaForm (state) { return state.MarcaForm },
    get_ProcedenciaForm (state) { return state.ProcedenciaForm },
    get_MovimientosFilterForm (state) { return state.MovimientosFilterForm },
    get_BajasFilterForm (state) { return state.BajasFilterForm },
    // ===== * ===== * ===== * ===== * ===== * ===== * ===== * ===== \\
    // ===== * ===== * ===== * ===== * ===== * ===== * ===== * ===== \\
    get_InsumosForm (state) { return state.InsumosForm },
    get_AssignRoles (state) { return state.AssignRoles },
    get_RemoveRol (state) { return state.RemoveRol },
    get_SelectDepartamentosForm (state) { return state.SelectDepartamentosForm },
    get_PreviewPdfForm (state) { return state.PreviewPdfForm },
    get_EditBajasForm (state) { return state.EditBajasForm },
    get_EditTransferenciasForm (state) { return state.EditTransferenciasForm },
    get_EnviarInventarioGral (state) { return state.EnviarInventarioGral },

    get_TicketsDepartamentoForm (state) { return state.TicketsDepartamentoForm },
    get_TicketsDepartamentoFormControlables (state) { return state.TicketsDepartamentoFormControlables },
    get_ReporteGeneralInventariablesForm (state) { return state.ReporteGeneralInventariablesForm }
  },
  mutations: {},
  actions: {}
})
